import { createContext, useContext, useState } from "react";
import { AlertContextProviderProps, AlertContextType } from "./ContextTypes";
import { AlertPropsType } from "../components/alertComp/AlertTypes";

const AlertContext = createContext<AlertContextType | undefined>(undefined)

export const AlertContextProvider = (props: AlertContextProviderProps) => {
    const [alert, setAlert] = useState<AlertPropsType[]>([]);

    const showAlert = (message: string, type: AlertPropsType["type"]) => {
        const id = crypto.randomUUID()

        setAlert(prevState => [...prevState, {id, type, message}])

        setTimeout(() => removeAlert(id), 10000)
    }

    const removeAlert = (id: string) => {
        setAlert(prevState => prevState.filter(alert => alert.id !== id))
    }

    return (
        <AlertContext.Provider value={{alert, showAlert, removeAlert}}>
            {props.children}
        </AlertContext.Provider>
    )
}

export const useAlert = () => {
    const context = useContext(AlertContext)

    if(!context) throw new Error("useAlert must be used within an AlertProvider")
    
    return context
}